export default {
    employment_cohort_1: 'Started in February',
    employment_cohort_2: 'Started in March',
    employment_cohort_3: 'Started in April',
    employment_cohort_4: 'Started in May',
    employment_cohort_13: 'Started in February 2022',
    employment_cohort_14: 'Started in March 2022',
    employment_cohort_15: 'Started in April 2022',
    employment_cohort_16: 'Started in May 2022',
    employment_cohort_17: 'Started in June 2022',
    employment_cohort_18: 'Started in July 2022',
    employment_cohort_19: 'Started in August 2022',
    employment_cohort_20: 'Started in September 2022',
    employment_cohort_21: 'Started in October 2022',
    employment_cohort_22: 'Started in November 2022',
    employment_cohort_23: 'Started in December 2022',
    employment_cohort_100: 'Started in 2021',
    employment_cohort_200: 'Started in 2022',
    employment_cohort_10000: 'All',
};
